import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "back",
  "use": "back-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"back\">\r\n<path d=\"M2.637,6.999l4.954-5.052C8,1.525,8,0.842,7.591,0.42c-0.409-0.421-1.072-0.421-1.481,0L0.408,6.236\r\n    C0,6.657,0,7.34,0.408,7.762l5.702,5.815c0.409,0.421,1.072,0.421,1.481,0C8,13.156,8,12.472,7.591,12.051L2.637,6.999z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol